/* eslint-disable*/

import React, {useEffect} from 'react'
import { Route, Switch, useHistory } from "react-router-dom";
import DashboardPage from "containers/DashboardPage";
import WaTemplate from 'containers/WaTemplate';
import GenerateReport from "containers/GenerateReport";
import MyApplicationRoute from "containers/MyApplicationPage";
import CreateTemplateWa from 'containers/WaTemplate/CreateTemplate';

// library
import moment from 'moment';
import { useDispatch } from "react-redux";

// servicess
import authSvc from "services/authSvc";
import { logout } from "_redux/actions/authAction";

function DashboardRoute() {
const path = "/main";

const currentUser = authSvc.currentUser();
const dispatch = useDispatch();
const history = useHistory();

useEffect(()=>{
  // let dataExpired = moment(currentUser?.expiredDate).format('DD-MM-YYYY HH:mm')
  // let CurrentDate = moment().format('DD-MM-YYYY HH:mm');

  // let per = CurrentDate > dataExpired;
  // if(per){
  //   onLogOut()
  // } 

},[])

function onLogOut() {
  dispatch(logout());
  localStorage.removeItem("DATA_FORM");
  history.push("/auth/login");
};

  return (
    <Switch>
      <Route path={`/dashboard`} component={DashboardPage} exact />
      <Route path={`/generate-report`} component={GenerateReport} exact />
      <Route path={`/whatsapp-template`} component={WaTemplate} exact />
      <Route path={`/create-whatsapp-template`} component={CreateTemplateWa} exact />
      <Route path={`/edit-whatsapp-template/:id`} component={CreateTemplateWa} exact />
      <Route component={MyApplicationRoute} />
    </Switch>
  )
}

export default DashboardRoute